document.addEventListener("DOMContentLoaded",()=>{

const hero=document.querySelector(".fx-hero");
const logo=document.querySelector(".fx-hero-logo");

if(!hero || !logo) return;

/* Desktop only */

if(window.innerWidth > 950){

    hero.addEventListener("mousemove",(e)=>{

        const rect=hero.getBoundingClientRect();

        const x=(e.clientX-rect.left)/rect.width-.5;
        const y=(e.clientY-rect.top)/rect.height-.5;

        logo.style.transform=
        `translate(${x*6}px,${y*6}px)`;

    });

    hero.addEventListener("mouseleave",()=>{

        logo.style.transform=
        "translate(0px,0px)";

    });

}

});